import { makeAutoObservable } from "mobx";

export class NumberValue {
  constructor(initialValue = 0) {
    makeAutoObservable(this);

    this.value = initialValue;
  }

  value = 0;

  setValue = (value) => {
    this.value = value;
  };
}
